// Translations
import landing from '../views/landing/translations/ru'

// Translation: Login (Russian)
export default Object.freeze({
	name: '',
	views: { landing }
})
